var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-blockui waiting"},[_c('span',[_vm._v("Please wait...")]),_c('span',[_c('div',{staticClass:"m-loader m-loader--brand"})])])
}]

export { render, staticRenderFns }